import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { RouterLinkType } from '@core/common.types';
import { MatBadgeModule } from '@angular/material/badge';

@Component({
  selector: 'app-header-link',
  template: `
    <a mat-flat-button [routerLink]="link" [attr.aria-label]="caption">
      <mat-icon
        *ngIf="icon"
        [svgIcon]="icon"
        [matBadge]="badgeCount"
        matBadgeSize="small"
        [matBadgeHidden]="!badgeCount || badgeCount <= 0"
        aria-hidden="false"
      />
      <span class="caption">{{ caption }}</span>
    </a>
  `,
  styleUrls: ['./header-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule, MatBadgeModule],
})
export class HeaderLinkComponent {
  @Input({ required: true }) caption: string;
  @Input({ required: true }) icon: string;
  @Input() badgeCount?: number;
  @Input({ required: true }) link: RouterLinkType;
}
